import React, { useEffect, useState } from 'react';
import './Confetti.css';

interface ConfettiProps {
  show: boolean;
  onComplete: () => void;
}

const Confetti: React.FC<ConfettiProps> = ({ show, onComplete }) => {
  const [particles, setParticles] = useState<Array<{
    id: number;
    x: number;
    y: number;
    color: string;
    rotation: number;
    scale: number;
    vx: number;
    vy: number;
    gravity: number;
  }>>([]);

  useEffect(() => {
    if (!show) {
      setParticles([]);
      return;
    }

    // Konfetti-Farben (festlich)
    const colors = ['#FFD700', '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEAA7', '#DDA0DD', '#98D8C8'];
    
    // Generiere Konfetti-Partikel
    const newParticles = Array.from({ length: 50 }, (_, i) => ({
      id: i,
      x: Math.random() * window.innerWidth,
      y: -10,
      color: colors[Math.floor(Math.random() * colors.length)],
      rotation: Math.random() * 360,
      scale: 0.5 + Math.random() * 0.5,
      vx: (Math.random() - 0.5) * 10, // Horizontale Geschwindigkeit
      vy: Math.random() * 3 + 2,      // Vertikale Geschwindigkeit
      gravity: 0.3 + Math.random() * 0.2
    }));

    setParticles(newParticles);

    // Animation und Auto-Cleanup
    const duration = 3000; // 3 Sekunden
    const timer = setTimeout(() => {
      setParticles([]);
      onComplete();
    }, duration);

    return () => clearTimeout(timer);
  }, [show, onComplete]);

  if (!show || particles.length === 0) {
    return null;
  }

  return (
    <div className="confetti-container">
      {particles.map((particle) => (
        <div
          key={particle.id}
          className="confetti-particle"
          style={{
            left: `${particle.x}px`,
            top: `${particle.y}px`,
            backgroundColor: particle.color,
            transform: `rotate(${particle.rotation}deg) scale(${particle.scale})`,
            '--vx': particle.vx,
            '--vy': particle.vy,
            '--gravity': particle.gravity,
          } as React.CSSProperties}
        />
      ))}
    </div>
  );
};

export default Confetti;